import {
    fetcherReactToPost,
    fetcherRemoveReactFromPost,
} from "../../../DataFetchers/PostDataFetcher";
import {
    AbstractReactionActor,
    ReactionActorActionMap,
} from "./AbstractReactionActor";
import { ReactionEntityName } from "../Reactions.types";
import {
    RESET_API_CACHE_REASONS,
    resetIgnoreApiCacheTime,
} from "@infrastructure/Services/ApiUtility";

export class PostReactionActor extends AbstractReactionActor {
    protected readonly actionMap: ReactionActorActionMap = {
        create: fetcherReactToPost,
        delete: fetcherRemoveReactFromPost,
    };

    protected readonly preAction: () => void = () => {
        resetIgnoreApiCacheTime(RESET_API_CACHE_REASONS.REACT_ON_POST);
    };

    readonly entityType: ReactionEntityName = "post";
}
